// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"3ef29d08","294":"ad4fb8b9","300":"9f727c2d","312":"0cce8663","329":"2c58b9ec","354":"088442b7","452":"ebea5c84","973":"668d7ae2"}[chunkId] + ".chunk.css";
};